import { Info } from "lucide-react";
import { reasonText } from "@/lib/marketing";

/**
 * A single metric. An unavailable metric is NEVER shown as zero — it renders
 * as an em dash carrying the Stage 2 machine-readable reason.
 */
export const MetricValue = ({ metric, format = (v) => v, testid, className = "" }) => {
  const value = metric && typeof metric === "object" ? metric.value : metric;
  const reason = metric && typeof metric === "object" ? metric.reason : null;
  if (value === null || value === undefined) {
    return (
      <span data-testid={testid} data-metric-state="unavailable"
        data-reason={reason || "unavailable"} title={reasonText(reason)}
        className={`inline-flex items-center gap-1 text-slate-400 ${className}`}>
        —<Info className="h-3 w-3" aria-hidden />
      </span>
    );
  }
  return (
    <span data-testid={testid} data-metric-state="available"
      title={(metric && metric.formula) || undefined} className={className}>
      {format(value)}
    </span>
  );
};
